export default {
    BACKEND_SERVER: 'https://1wviixlnij.execute-api.eu-central-1.amazonaws.com/production',
    REGION: 'eu-central-1',
    USER_POOL_ID: 'eu-central-1_Zzcv31Abj',
    USER_POOL_APP_CLIENT_ID: 'nv6nn6fvspf1lvuvig2l8mk1i',
    IDENTITY_POOL_ID: 'eu-central-1:6b766407-e367-4ddf-8778-a7aace6c7aef',
    WIRING_DIAGRAM_BUCKET: 'ta-wiring-diagram-rdp-production',
    WIRING_DIAGRAM_BULK_UPLOAD_BUCKET: 'ta-wiring-diagram-rdp-bulk-upload-production',
    JWT_EXPIRE_IN: '1h',
    USER_POOL_DOMAIN: 'wiring-diagram-user-pool-prod.auth.eu-central-1.amazoncognito.com',
    APP_DIRECT_URL: 'https://www.wiring-diagram.tecalliance.cloud/',
    AZURE_REDIRECT_URL: 'https://www.wiring-diagram.tecalliance.cloud/user-management/blank.html',
    IDENTITY_PROVIDER: 'TecAllianceConnectID',
    AZURE_APP_ID: '945c7ffc-98a2-4be1-a3b5-05731c75d20a',
    TENANT_ID: '91262959-85ec-4b1c-b7d3-7c3aac19c595',
    USER_POOL_GROUPS: {
        ADMIN: 'admins_prod',
        USER: 'users_prod'
    },
    AZURE_GROUP_ID: [
        '76983e0a-126f-44b3-97d2-9478a08ef8ac',
        'c45e1c91-7a2e-4148-81ec-951f0cc21a95'
    ],
    USE_SSO: true,
    SHOW_API_DOCUMENTATION: false,
    USE_REDRAWING_TU_VERSION: true,
    ENABLE_MANUAL_USER_UPLOAD: false,
    DSML_API_KEY: '2xTYAlcAXm6tG3kZYSGy16vUPVeiwhmC7zCRoc0O', // api key is provided by DSML
    DSML_API_URL: 'https://jcobm1f8oi.execute-api.eu-central-1.amazonaws.com/dev',
}
